import {
    FETCH_ORDERS_REQUEST,
    FETCH_ORDERS_SUCCESS,
    FETCH_ORDERS_FAILURE,
    UPDATE_DELIVERY_INFO_SUCCESS,
  } from "../actions/orderActions";
  
  const initialState = {
    loading: false,
    orders: [],
    error: null,
  };
  
  const orderReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_ORDERS_REQUEST:
        return { ...state, loading: true };
      case FETCH_ORDERS_SUCCESS:
        return { ...state, loading: false, orders: action.payload, error: null };
      case FETCH_ORDERS_FAILURE:
        return { ...state, loading: false, error: action.payload };
      case UPDATE_DELIVERY_INFO_SUCCESS: {
        const { orderId, deliveryData } = action.payload;
        return {
          ...state,
          orders: state.orders.map((o) =>
            o.orderId === orderId ? { ...o, ...deliveryData } : o
          ),
        };
      }
      default:
        return state;
    }
  };
  
  export default orderReducer;
  